import { sortReceiptPackagesByStockNo } from './sortReceiptPackagesByStockNo';

/**
 * stock-receipt API lines[] → DetailTable expanding rows（含 packageList）。
 * line／package 的 id 僅供 React key；API 不回傳內部 id。
 * packageList 依庫編升序（空值最後）。
 */
export function adaptStockReceiptLinesForTable(lines = []) {
  return lines.map((line, lineIndex) => {
    const mtr = line.mtr ?? line.material ?? null;
    const lineUnit = line.unit ?? null;

    return {
      id: line.id ?? `line-${lineIndex}`,
      mtrId: line.mtrId ?? mtr?.id ?? null,
      unitPrice: line.unitPrice,
      amount: line.amount,
      remark: line.remark,
      material: mtr,
      unit: lineUnit,
      convertRate: line.convertRate ?? null,
      packageList: sortReceiptPackagesByStockNo(
        (line.packages ?? []).map((pkg, pkgIndex) => {
          const inventoryStockId = pkg.invStock?.id ?? pkg.inventoryStockId ?? null;
          const qty = pkg.qty ?? pkg.quantity;

          return {
            id: pkg.id ?? `pkg-${lineIndex}-${pkgIndex}`,
            inventoryStockId,
            qty,
            quantity: qty,
            stockNo: pkg.invStock?.stockNo ?? pkg.stockNo ?? null,
            locationId: pkg.locationId,
            location: pkg.location,
            remark: pkg.remark,
          };
        }),
      ),
    };
  });
}
